import { GetBasketHistoryForm, GetBasketHistoryList, GetBasketWalletInfo, GetBasketWalletList, GetBrokerInfo, GetBrokerInfoDetail, GetPortfolioBasketMenuViewList, GetPortfolioWalletInfo, GetPortfolioWalletList, GetRequestHistoryForm, GetRequestHistoryList } from "./api";

import http from "config/http";

const walletApi = {
  getPortfolioWalletList: async ({ isShowMore, id }) => await http.get(GetPortfolioWalletList({ isShowMore, id })),

  getBasketWalletList: async ({ isShowMore, id, portfolioId }) => await http.get(GetBasketWalletList({ isShowMore, id, portfolioId })),

  getBasketWalletInfo: async ({ id, portfolioId }) => await http.get(GetBasketWalletInfo({ id, portfolioId })),
  getPortfolioWalletInfo: async ({ id }) => await http.get(GetPortfolioWalletInfo({ id })),

  getPortfolioBasketMenuViewList: async () => await http.get(GetPortfolioBasketMenuViewList),

  getBasketHistoryForm: async () => await http.get(GetBasketHistoryForm),
  getBasketHistoryList: async ({ basketId, typeId, coinId, startDate, endDate, transferId, repayId, pageNumber, pageSize }) => await http.get(GetBasketHistoryList({ basketId, typeId, coinId, startDate, endDate, transferId, repayId, pageNumber, pageSize })),

  getRequestHistoryForm: async () => await http.get(GetRequestHistoryForm),
  getRequestHistoryList: async ({ sideId, typeId, forId, stateId, coinId, basketId, userName, startDate, endDate, pageNumber, pageSize }) => await http.get(GetRequestHistoryList({ sideId, typeId, forId, stateId, coinId, basketId, userName, startDate, endDate, pageNumber, pageSize })),

  getBrokerInfo: async ({ brokerId }) => await http.get(GetBrokerInfo({ brokerId })),
  getBrokerInfoDetail: async ({ brokerId }) => await http.get(GetBrokerInfoDetail({ brokerId }))
};

export default walletApi;
